import KendoScrollView from './KendoScrollView'
import KendoScrollViewInstaller from './kendo-scrollview-installer'

export { KendoScrollView, KendoScrollView as ScrollView, KendoScrollViewInstaller, KendoScrollViewInstaller as ScrollViewInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-scrollview-vue-wrapper/src/index.js